import constants from "../constants";

export default function (token, options) {

  let params = [`token=${encodeURIComponent(token)}`];
  let downloadFileURL = (options ? options.downloadFileURL : null) || constants.DOWNLOAD_FILE_URL.DEFAULT_URL;

  if (options) for (let key in options)
    params.push(`${key}=${encodeURIComponent(options[key])}`);

  return token && token.length ? `${constants.BASE_SERVICE_URL}${downloadFileURL}?${params.join("&")}` : null;
}



// WEBPACK FOOTER //
// ./src/filters/buildAttachmentURL.js